import { AgentSearch, AgentSearchProps } from 'components/agent-search';
import HeadData from 'components/head-data';
import Layout from 'components/layout';
import { v4 as uuid } from 'uuid';
import { AgentType } from 'utils/agent-endpoint';
import { isTenantExpCommercial, TenantIds, TenantTypes } from 'tenants';
import { FeaturesType } from 'contexts';
import { createGetServerSideProps, HandlerType } from 'utils/next/shared-getServerSideProps';
import { NOT_FOUND } from 'constants/not-fount';

import type { GetServerSidePropsContext } from 'next';

const handler: HandlerType<AgentSearchProps> = async (_context: GetServerSidePropsContext, _features?: FeaturesType, tenant?: TenantTypes) => {
  if (!tenant || !isTenantExpCommercial(tenant.id)) {
    return NOT_FOUND;
  }

  const sessionId = uuid();

  let title, metaDescription;
  switch (tenant.id) {
    case TenantIds.EXP_COMMERCIAL:
      title = 'Find An Advisor - eXp Commercial';
      metaDescription = 'Find a commercial real estate advisor. Search for commercial real estate agents and brokers on eXp Commercial.';
      break;
    default:
      title = `Find a Local Real Estate Agent ${tenant.theme.title}`;
      metaDescription = tenant.theme.metaDescription;
  }

  return {
    props: {
      agentType: AgentType.COMMERCIAL,
      initialCountry: 'US',
      sessionId,
      tenantId: tenant.id,
      headerData: {
        title,
        metaDescription,
      },
    },
  };
};

export const getServerSideProps = createGetServerSideProps<AgentSearchProps>(handler);

export default function AgentsPage(props: AgentSearchProps) {
  return (
    <Layout>
      <HeadData data={props.headerData} />
      <AgentSearch {...props} />
    </Layout>
  );
}